import { Col, FormGroup, FormInput, Input, Row } from '@snsw/react-component-library';
import { PlantItemDetailsPage } from 'plantItemNew/constants/plantItemDetailsPage';
import React, { useEffect, useState } from 'react';
import { isEmpty, isNumeric, validateExt } from 'shared/utils/Validation';
import styles from '../PlantItemDetails.module.scss';

export const EscalatorDetails = React.forwardRef((props, ref) => {
  const { value = {}, onChange = () => {}, refData = {}, onErrorChange = () => {} } = props;
  const {
    maxSpeed: savedMaxSpeed = '',
    maxAngle: savedMaxAngle = '',
    maxTravel: savedMaxTravel = '',
    maxWidth: savedMaxWidth = '',
    maxPassengers: savedMaxPassengers = '',
  } = value;

  const [maxSpeed, setMaxSpeed] = useState(savedMaxSpeed);

  const [maxAngle, setMaxAngle] = useState(savedMaxAngle);
  const [maxTravel, setMaxTrave] = useState(savedMaxTravel);
  const [maxWidth, setMaxWidth] = useState(savedMaxWidth);
  const [maxPassengers, setMaxPassengers] = useState(savedMaxPassengers);
  const [showErrors, setShowErrors] = useState(false);

  const [errors, setErrors] = useState({});
  const [errorSummary, setErrorSummary] = useState([]);

  const validators = [
    {
      fieldName: 'maxSpeed',
      fieldValue: maxSpeed,
      isValid: isNumeric,
      errorMessage: (v) => (isEmpty(v) ? 'Please enter details' : 'Please enter only numeric value'),
    },
    {
      fieldName: 'maxAngle',
      fieldValue: maxAngle,
      isValid: isNumeric,
      errorMessage: (v) => (isEmpty(v) ? 'Please enter details' : 'Please enter only numeric value'),
    },
    {
      fieldName: 'maxTravel',
      fieldValue: maxTravel,
      isValid: isNumeric,
      errorMessage: (v) => (isEmpty(v) ? 'Please enter details' : 'Please enter only numeric value'),
    },
    {
      fieldName: 'maxWidth',
      fieldValue: maxWidth,
      isValid: isNumeric,
      errorMessage: (v) => (isEmpty(v) ? 'Please enter details' : 'Please enter only numeric value'),
    },
    {
      fieldName: 'maxPassengers',
      fieldValue: maxPassengers,
      isValid: isNumeric,
      errorMessage: (v) => (isEmpty(v) ? 'Please enter details' : 'Please enter only numeric value'),
    },
  ];

  if (ref) {
    ref.current = {
      validate: () => {
        let isCurrentComponentValid = validateExt(validators, setErrors, setErrorSummary);

        setShowErrors(!isCurrentComponentValid);

        return isCurrentComponentValid;
      },
    };
  }

  useEffect(() => {
    let details = {
      maxSpeed,
      maxAngle,
      maxTravel,
      maxWidth,
      maxPassengers,
    };
    onChange(details);

    if (showErrors) validateExt(validators, setErrors, setErrorSummary);
  }, [maxSpeed, maxAngle, maxTravel, maxWidth, maxPassengers]);

  useEffect(() => {
    onErrorChange(errorSummary);
  }, [errorSummary]);

  return (
    <>
      <Row>
        <Col span={4}>
          <FormInput
            id="maxSpeed"
            label={PlantItemDetailsPage.relatedDetails.escalator.maxSpeedLabel}
            suffix="m/s"
            onChange={(e) => {
              setMaxSpeed(e.target.value);
            }}
            value={maxSpeed}
            errorMessage={errors?.maxSpeed?.errorMessage}
            hasError={showErrors && errors?.maxSpeed?.invalid}
            className={styles.inputWithSuffix}
          />

          <FormInput
            id="maxAngle"
            label={PlantItemDetailsPage.relatedDetails.escalator.maxAngleLabel}
            suffix="degrees"
            onChange={(e) => {
              setMaxAngle(e.target.value);
            }}
            value={maxAngle}
            errorMessage={errors?.maxAngle?.errorMessage}
            hasError={showErrors && errors?.maxAngle?.invalid}
            className={styles.inputWithSuffix}
          />

          <FormInput
            id="maxTravel"
            label={PlantItemDetailsPage.relatedDetails.escalator.maxTravelLabel}
            suffix="m"
            onChange={(e) => {
              setMaxTrave(e.target.value);
            }}
            value={maxTravel}
            errorMessage={errors?.maxTravel?.errorMessage}
            hasError={showErrors && errors?.maxTravel?.invalid}
            className={styles.inputWithSuffix}
          />

          <FormInput
            id="maxWidth"
            label={PlantItemDetailsPage.relatedDetails.escalator.maxWidthLabel}
            suffix="m"
            onChange={(e) => {
              setMaxWidth(e.target.value);
            }}
            value={maxWidth}
            errorMessage={errors?.maxWidth?.errorMessage}
            hasError={showErrors && errors?.maxWidth?.invalid}
            className={styles.inputWithSuffix}
          />

          <FormGroup
            id="maxPassengers"
            label={PlantItemDetailsPage.relatedDetails.escalator.maxPassengersLabel}
            isRequired
            errorMessage={errors?.maxPassengers?.errorMessage}
            hasError={showErrors && errors?.maxPassengers?.invalid}
          >
            <Input
              onChange={(e) => {
                setMaxPassengers(e.target.value);
              }}
              value={maxPassengers}
              inputWidth="sm"
            />
          </FormGroup>
        </Col>
      </Row>
    </>
  );
});

EscalatorDetails.displayName = 'EscalatorDetails';
